module.exports = __webpack_public_path__ + "static/media/0336_Medium.5c0de844.jpg";